/* eslint-disable security/detect-object-injection */
import * as React from 'react';
import { Form } from 'react-bootstrap';

import { FormContext } from '@/helper/context';
import { camelToTitle } from '@/helper/utility';

interface Properties {
  name: string;
  displayName?: string;
  size?: string;
  value?: string;
  valueSelect?: string;
}

export function Input({ name, displayName, size = 'col-12', value, valueSelect }: Properties) {
  if (!displayName) displayName = camelToTitle(name);
  const [valueState, setValueState] = React.useState((valueSelect ?? value) || '');
  const { changeTracker, setWasChanged, disabled, errors } = React.useContext(FormContext);

  React.useEffect(() => {
    const didChange = valueSelect ? (valueSelect == value ? false : true) : false;
    changeTracker.current = {
      ...changeTracker.current,
      [name]: didChange
    };
    setWasChanged(Object.values(changeTracker.current).includes(true));
  }, []);

  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    setValueState(event.target.value);

    const didChange = event.target.value == value ? false : true;
    changeTracker.current = {
      ...changeTracker.current,
      [event.target.name]: didChange
    };
    setWasChanged(Object.values(changeTracker.current).includes(true));
  }

  return (
    <Form.Group controlId={name} className={`mt-3 ${size}`}>
      <Form.Label>{displayName}</Form.Label>
      <Form.Control
        type='text'
        name={name}
        disabled={disabled}
        value={valueState}
        onChange={onChange}
        isInvalid={errors[name] ? true : false}
        autoComplete='off'
      />
      <Form.Control.Feedback type='invalid'>{errors[name]}</Form.Control.Feedback>
    </Form.Group>
  );
}
